import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { forwardRef, inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CustomURLEncoder } from '../encoders/customHttpParamsEncoder';
import { EXCLUDED_ENDPOINTS } from './impersonate-interceptor.constants';
import { ImpersonateService } from './impersonate.service';

export const IMPERSONATED_USER_INTERCEPTOR = {
  provide: HTTP_INTERCEPTORS,
  useClass: forwardRef(() => ImpersonateInterceptor),
  multi: true,
};

@Injectable()
export class ImpersonateInterceptor implements HttpInterceptor {
  injector = inject(Injector);
  private router = inject(Router);
  private impersonateService = inject(ImpersonateService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isExcluded = EXCLUDED_ENDPOINTS.some((endpoint) => endpoint.method === request.method && endpoint.pattern.test(request.url));

    if (this.impersonateService.impersonated() && !isExcluded) {
      const impersonatedUserEmail = this.impersonateService.getImpersonatedUserEmail();

      const params = new HttpParams({ fromString: request.params.toString(), encoder: new CustomURLEncoder() }).append(
        '_impersonate',
        impersonatedUserEmail,
      );

      request = request.clone({
        params,
      });
    }

    return next.handle(request);
  }
}
